// SponsorModal.js
import React from 'react';
import Swal from 'sweetalert2';
import { createSponsorPaymentSession } from '../lib/adminapi';
// ^ Adjust if your API function is in another file

const SponsorModal = ({ onClose, eventId }) => {
    /**
     * handleSponsor - Called when user clicks "1 Day", "1 Week", etc.
     * 1) Calls our sponsor payment session endpoint
     * 2) If success => redirect to PayTabs
     */
    const handleSponsor = async (duration) => {
        try {
            // e.g. duration is 'day', 'week', or 'month'
            const response = await createSponsorPaymentSession(eventId, duration);
            if (response && response.paymentUrl) {
                // Redirect user to the hosted payment page
                window.location.href = response.paymentUrl;
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Payment Error',
                    text: 'Could not create sponsor payment session.',
                });
            }
        } catch (error) {
            console.error('Error creating sponsor payment session:', error);
            Swal.fire({
                icon: 'error',
                title: 'Payment Error',
                text: error.message || 'Failed to initiate sponsorship payment.',
            });
        }
    };

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
            onClick={onClose} // Close modal if user clicks on background
        >
            <div
                className="bg-[#303261] p-8 rounded-lg w-full max-w-md text-white"
                onClick={(e) => e.stopPropagation()}
            // stopPropagation so clicking inside the modal doesn't close it
            >
                <h2 className="text-2xl font-semibold mb-6 text-center">
                    Feature This Event
                </h2>

                <div className="flex justify-between space-x-4">
                    {/* 1 Day Sponsor */}
                    <div
                        className="flex flex-col items-center justify-center bg-[#4954a5] p-4 
                       rounded-lg cursor-pointer hover:bg-[#574bfc] flex-1"
                        onClick={() => handleSponsor('day')}
                    >
                        <span className="text-sm md:text-xl font-bold">1 Day</span>
                        <span className="text-sm md:text-xl mt-2">5 JOD</span>
                    </div>

                    {/* 1 Week Sponsor */}
                    <div
                        className="flex flex-col items-center justify-center bg-[#4954a5] p-4 
                       rounded-lg cursor-pointer hover:bg-[#574bfc] flex-1"
                        onClick={() => handleSponsor('week')}
                    >
                        <span className="text-sm md:text-xl font-bold">1 Week</span>
                        <span className="text-sm md:text-xl mt-2">30 JOD</span>
                    </div>

                    {/* 1 Month Sponsor */}
                    <div
                        className="flex flex-col items-center justify-center bg-[#4954a5] p-4 
                       rounded-lg cursor-pointer hover:bg-[#574bfc] flex-1"
                        onClick={() => handleSponsor('month')}
                    >
                        <span className="text-sm md:text-xl font-bold">1 Month</span>
                        <span className="text-sm md:text-xl mt-2">120 JOD</span>
                    </div>
                </div>

                {/* Optional close or cancel button */}

            </div>
        </div>
    );
};

export default SponsorModal;
